import styled from "styled-components";

import { colors } from "shared/ui";

const COLUMNS =
    "minmax(90px, 0.9fr) 74px minmax(130px, 1.1fr) minmax(90px, 0.8fr) minmax(100px, 0.8fr) minmax(150px, 1.1fr) minmax(120px, 0.9fr) 52px";
const NARROW = "1023px";

export const List = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeaderRow = styled.div`
    display: grid;
    grid-template-columns: ${COLUMNS};
    gap: 12px;
    align-items: center;
    padding: 0 4px 8px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        display: none;
    }
`;

/*
* Одна разметка на оба вьюпорта: на узком строка раскладывается в блок
* (номер и отмена сверху, остальные поля — подписанными строками ниже).
* */
export const Row = styled.div`
    display: grid;
    grid-template-columns: ${COLUMNS};
    gap: 12px;
    align-items: center;
    padding: 12px 4px;
    border-top: 1px solid ${colors.borderSofter};

    &:hover {
        background: ${colors.contentBg};
    }

    @media (max-width: ${NARROW}) {
        grid-template-columns: 1fr auto;
        grid-template-areas:
            "number actions"
            "type type"
            "tariff tariff"
            "amount amount"
            "status status"
            "date date"
            "links links";
        gap: 6px;
        padding: 14px 4px;
    }
`;

export const Cell = styled.div`
    min-width: 0;
    color: ${colors.textPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${NARROW}) {
        display: flex;
        gap: 8px;
        white-space: normal;
    }
`;

export const NumberCell = styled(Cell)`
    font-weight: 600;

    @media (max-width: ${NARROW}) {
        grid-area: number;
    }
`;

export const TypeCell = styled(Cell)`
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        grid-area: type;
    }
`;

export const TariffCell = styled(Cell)`
    @media (max-width: ${NARROW}) {
        grid-area: tariff;
    }
`;

export const AmountCell = styled(Cell)`
    @media (max-width: ${NARROW}) {
        grid-area: amount;
    }
`;

export const StatusCell = styled(Cell)<{ $tone: "success" | "warning" | "danger" }>`
    color: ${({ $tone }) => {
        if ($tone === "success") return colors.success;
        if ($tone === "danger") return colors.danger;
        return colors.amber;
    }};

    @media (max-width: ${NARROW}) {
        grid-area: status;
    }
`;

export const DateCell = styled(Cell)`
    color: ${colors.textSecondary};

    @media (max-width: ${NARROW}) {
        grid-area: date;
    }
`;

export const LinksCell = styled(Cell)`
    white-space: normal;

    @media (max-width: ${NARROW}) {
        grid-area: links;
    }
`;

export const LinkButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
`;

// Подпись поля нужна только в блочной раскладке — на широком её роль играет шапка таблицы.
export const CellLabel = styled.span`
    display: none;

    @media (max-width: ${NARROW}) {
        display: block;
        flex: 0 0 96px;
        font-size: 13px;
        color: ${colors.textSecondary};
    }
`;

export const CellValue = styled.span`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;

    @media (max-width: ${NARROW}) {
        grid-area: actions;
    }
`;
